export default __webpack_public_path__ + "static/media/antioquiaitagui.1a4e2174.jpg";